/**
 * Can be used especially when the user logs in or creates a new account. In this way, the email will always be checked/stored in a lowercase format and without whitespacing
 */

export const cleanEmail = (email: string): string => {
  return email.toLocaleLowerCase().trim();
};
